import { IconChevronRight16, Image, UIHeading5, UIText2 } from '@cian/ui-kit';
import bannerImage from './assets/image.svg';
import * as styles from './BuildersBanner.css';

import * as React from 'react';
import { NBSP } from '../../constants/symbols';
import { BUILDERS_LIST_LINK } from '../../constants/links';

export const BuildersBanner: React.FC = () => {
  return (
    <a href={BUILDERS_LIST_LINK} className={styles['link']}>
      <div className={styles['container']}>
        <Image src={bannerImage} width={60} height={60} />
        <div>
          <UIHeading5>Строительные компании</UIHeading5>
          <UIText2 color="gray60_100">
            Проверили историю и{NBSP}отзывы о{NBSP}работе
          </UIText2>
        </div>
        <IconChevronRight16 color="gray60_100" />
      </div>
    </a>
  );
};
